import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

function initUniversitiesSlider() {
  new Swiper('.js-universitiesSlider', {
    loop: true,
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 32,
    navigation: {
      nextEl: '.universities-button-next',
      prevEl: '.universities-button-prev',
    },
    // pagination: {
    //   el: '.swiper-pagination',
    //   type: 'fraction',
    // },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
      1025: {
        slidesPerView: 5,
        spaceBetween: 34,
      },
    },
  })
}

initUniversitiesSlider()

$(document).on('triggerUniversitiesSlider', () => {
  initUniversitiesSlider()
})
